import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DoctorlicenseComponent } from './doctorlicense/doctorlicense.component';
import { PaywebcomponentComponent } from './paywebcomponent/paywebcomponent.component';
import { PaywebsuccessComponent } from './paywebsuccess/paywebsuccess.component';
import { PaywebfailedComponent } from './paywebfailed/paywebfailed.component';

const routes: Routes = [
  {path : 'dclicense',component:DoctorlicenseComponent},
  {path : 'payweb',component:PaywebcomponentComponent},
  {path : 'paywebstatus',component:PaywebsuccessComponent},
  {path : 'paywebpending',component:PaywebfailedComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicenseIsuueRoutingModule { }
